// Per-user feature flag check for the redirect (user) portal.
//
// Backend stores enabled features in rc_blocked_features (misnomer — the
// array represents what the user IS granted, per the admin UI label
// "Enable Feature"). Login response sets `blocked_features: [...]`
// in the body (webapi/resources/login.py:140), and the user portal
// persists the whole login payload at localStorage[`user_${current_user}`].
//
// Existing callers follow this exact pattern (see XmlCdr.jsx:134-138 and
// report/XmlCdr.jsx:46-51) — this helper centralises the parse so we
// don't repeat the localStorage / JSON.parse boilerplate at every gate.
export function hasUserFeature(featureKey) {
  try {
    const currentUser = localStorage.getItem("current_user");
    if (!currentUser) return false;
    const raw = localStorage.getItem(`user_${currentUser}`);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return (
      Array.isArray(parsed?.blocked_features) &&
      parsed.blocked_features.includes(featureKey)
    );
  } catch {
    return false;
  }
}
